var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1351,
		165
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1344,
		243
	],
	"./MarketingCards.vue": [
		371
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1345,
		244
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1352,
		112
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		466
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		461
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1321;
module.exports = webpackAsyncContext;